import { render, staticRenderFns } from "./formItemProperties.vue?vue&type=template&id=0547367a&"
import script from "./formItemProperties.vue?vue&type=script&lang=js&"
export * from "./formItemProperties.vue?vue&type=script&lang=js&"
import style0 from "./formItemProperties.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports